import { useTranslation } from "react-i18next";
import { Clock, Timer, Hourglass } from "lucide-react";
import { Field } from "../../../components/neu/Field";
import { AttendancePolicyFields } from "./AttendancePolicyFields";
import { DayPicker } from "./DayPicker";
import { YesNo } from "./Chip";

export const ShiftTab = ({ form, set, setNested, attendancePolicy }) => {
  const { t } = useTranslation();

  return (
    <div>
    <div className="grid gap-5 sm:grid-cols-2">
      <Field label={t("branches.workStart")} testId="branch-work_start" type="time" value={form.work_start} onChange={(v) => set("work_start", v)} accent="sky" icon={Clock} raised />
      <Field label={t("branches.workEnd")} testId="branch-work_end" type="time" value={form.work_end} onChange={(v) => set("work_end", v)} accent="violet" icon={Hourglass} raised />
      <Field
        label={t("branches.grace")} testId="branch-grace_minutes" type="number"
        value={form.grace_minutes} onChange={(v) => set("grace_minutes", v)}
        accent="amber" icon={Timer}
      />

      <DayPicker form={form} set={set} />

      <YesNo
        label={t("branches.allowWeekendWork")} testId="branch-allow_weekend_work"
        value={!!form.allow_weekend_work} onChange={(v) => set("allow_weekend_work", v)}
      />
      <YesNo
        label={t("branches.weekendOvertime")} testId="branch-weekend_counts_as_overtime"
        value={!!form.weekend_counts_as_overtime} onChange={(v) => set("weekend_counts_as_overtime", v)}
      />
    </div>

      <div className="mt-7 pt-5" data-testid="branch-attendance-policy">
        <p className="label-xs mb-1">{t("branches.attendancePolicy")}</p>
        <p className="mb-4 text-xs text-muted-foreground">{t("branches.branchOverrideHint")}</p>
        <AttendancePolicyFields
          value={form.attendance || {}}
          defaults={attendancePolicy}
          onChange={(key, v) => setNested("attendance", key, v)}
        />
      </div>
    </div>
  );
};
